import React from 'react';

const ProjectDrawingOfficeIfasIndex = React.lazy(() => import("./index"))
const NewProjectDrawingOfficeIfas = React.lazy(() => import("./new"))
const EditProjectDrawingOfficeIfas = React.lazy(() => import("./edit"))
const ShowProjectDrawingOfficeIfas = React.lazy(() => import("./show"))

export default[
	{path:'/project/:project_id/drawing_office/ifas/:id/edit',component: EditProjectDrawingOfficeIfas,name:'Edit ProjectDrawingOfficeIfa'},
	{path:'/project/:project_id/drawing_office/ifas/new',component: NewProjectDrawingOfficeIfas,name:'New ProjectDrawingOfficeIfa'},
	{path:'/project/:project_id/drawing_office/ifas/:id',component: ShowProjectDrawingOfficeIfas,name:'ProjectDrawingOfficeIfa'},
	{path:'/project/:project_id/drawing_office/ifas',component: ProjectDrawingOfficeIfasIndex,name:'ProjectDrawingOfficeIfas'}, 
]
